import type { ToolReportDailyEntry } from '../../models'
import type { ToolReportingService } from '../../services'
import type { ToolReportingDailyComposable, ToolReportingDailyComposableParams } from './types'
import { ref, watch } from 'vue'
import { CONTAINER } from '../../config/inversify.config'
import { TYPES } from '../../config/inversify.types'
import { useFilters } from '../use-filters'

export function useToolReportingDaily(
  params: ToolReportingDailyComposableParams,
): ToolReportingDailyComposable {
  const dailyInfo = ref<ToolReportDailyEntry[]>([])
  const loading = ref(false)
  const hasErrors = ref(false)
  const { selectedDates } = useFilters()

  const getDailyInfo = async ({
    tool,
    toolId,
  }: ToolReportingDailyComposableParams): Promise<void> => {
    loading.value = true
    hasErrors.value = false
    const [startDate, endDate] = selectedDates.value
    try {
      const service = CONTAINER.get<ToolReportingService>(TYPES.ToolReportingService)
      dailyInfo.value = await service.getDailyData({
        tool,
        toolId,
        startDate: new Date(startDate).toISOString(),
        endDate: new Date(endDate).toISOString(),
      })
      loading.value = false
    } catch (error) {
      loading.value = false
      hasErrors.value = true
    }
  }

  watch(
    () => params,
    () => {
      void getDailyInfo(params)
    },
    { immediate: true, deep: true },
  )

  return {
    dailyInfo,
    hasErrors,
    loading,
  }
}
